module.exports = __webpack_public_path__ + "static/media/success-font.65aa39c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sku/success-font.png
// module id = 804
// module chunks = 0